




























import { computed, defineComponent } from "@vue/composition-api";
import useAdminManagedUser from "@/hooks/useAdminManagedUser";
import { UploadVaultFile } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import { LoadingThumbnail } from "@/components/ContentLoadingPlaceholders";
import VaultFileItemWithPreview from "./components/VaultFileItemWithPreview.vue";
import { UsedFilesMap } from "../../types";

export default defineComponent({
  name: "VaultFiles",
  components: { LoadingThumbnail, VaultFileItemWithPreview, BaseIcon },
  props: {
    files: { type: Array as () => UploadVaultFile[], required: true },
    thumbnails: { type: Boolean, default: false },
    fileClasses: { type: Object as () => Record<string, string> },
    usedFilesMap: { type: Object as () => UsedFilesMap },
  },
  setup(props) {
    const { isAdminManagedUser: allowDownload } = useAdminManagedUser();

    const vaultFiles = computed<UploadVaultFile[]>(() => {
      if (props.thumbnails && props.files.length > 0) {
        const f: UploadVaultFile[] = [];
        while (f.length < 4) {
          props.files.forEach((file: UploadVaultFile) => {
            f.push({ ...file, id: f.length.toString() });
          });
        }
        f.length = 4;
        return f;
      } else return props.files;
    });

    const uploadProgress = (file: UploadVaultFile): number => file?.uploadProgress ?? 100;

    const isFileUsed = (uuid: string) => !!props.usedFilesMap?.[uuid] ?? false;

    return {
      vaultFiles,
      isFileUsed,
      uploadProgress,
      allowDownload,
    };
  },
});
